import { report_geofenceService } from '../_services';

const state = { onRequest: false, report_geofence: [] };

const actions = {
    get_data({ dispatch, commit }, data) {
        commit('request');

        report_geofenceService.get_data(data)
            .then(
                resp => {
                    commit('success_data', resp);
                },
                error => {
                    commit('error');
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    clear_data({ commit }) {
        commit('clear_data');
    },
};
const getters = {
  onRequest: state => {
    return state.onRequest
  },
  report_geofence: state => {
    return state.report_geofence
  },
};

const mutations = {
    request(state) {
        state.onRequest = true;
        state.report_geofence = [];
    },
    success(state) {
      state.onRequest = false;
    },
    success_data(state, data) {
      state.onRequest = false;
      state.report_geofence = data;
    },
    clear_data(state) {
      state.onRequest = false;
      state.report_geofence = [];
    },
    error(state) {
        state.onRequest = false;
    },
};

export const report_geofences = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations
};
